/**
 * Products whose price is typed in per line, not held on the product record.
 *
 * Equipment is the case that prompted this (Task 24551): the product exists so
 * the line can be categorised and reported on, but it has no meaningful standard
 * price, so `AmountLocalSubTotal` sits at 0. Every line form seeds the price from
 * the product the moment you pick one, which meant typing the price first and
 * then choosing the product silently wiped what you typed back to 0.
 *
 * `Product.FlagPriceManualEntry` says "there is no standard price here, leave
 * whatever is on the line alone". Unit type, VAT and default quantity still come
 * across - it is only the money that is the user's to enter.
 *
 * The column is a MySQL TINYINT, so it arrives as the string "1" or "0" over the
 * API and as a boolean out of a form; both are handled here so callers never
 * have to think about it.
 */
export const isManualPriceProduct = (product) =>
  String(product?.FlagPriceManualEntry ?? "0") === "1" ||
  product?.FlagPriceManualEntry === true;

export default isManualPriceProduct;
